// Lib Imports
import React, { useEffect, useState, useCallback } from 'react';
import { Box, Heading, Text } from 'grommet';
import useQuery from 'granite-admin/utils/useQuery';

import Loader from 'granite-admin/core/components/Loader';
const quiversBaseUrl = process.env.REACT_APP_QUIVERS_ADMIN_URL;

const Success = () => {
  const [loader, setLoader] = useState(true);
  const { query } = useQuery();

  const fetchData = useCallback(async () => {
    setLoader(false);
    if (window.opener) {
      window.close();
    } else if (query?.ref_id && query?.plugin_id) {
      const ref_id = query.ref_id;
      const plugin_id = query.plugin_id;
      setTimeout(() => {
        window.location.href = `${quiversBaseUrl}#/${ref_id}/app_settings/${plugin_id}`;
      }, 3000);
    } else {
      setTimeout(() => {
        window.close();
      }, 3000);
    }
  }, [query]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Box flex align="center" justify="center" background="white" pad="xxlarge">
      {loader ? (
        <Box fill align="center" justify="center">
          <Loader />
        </Box>
      ) : (
        <>
          <Box fill align="center" justify="center">
            <Heading level={1} size="medium">
              Connection Successful
            </Heading>
            <Text size="large">Returning back to Quivers Plugin Console</Text>
            <Text size="large">Do not press any key.</Text>
          </Box>
        </>
      )}
    </Box>
  );
};

Success.propTypes = {
  // add your proptypes here
};

export default Success;
